<div fxLayout=row fxLayoutAlign="space-around center">
  <mat-card style="width: 100%">
    <mat-card-title>
      <h3 i18n>Orders list</h3>
      <span class="add-order">
        <button mat-fab color="accent" [routerLink]="['/order/add']">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-card-title>
    
    
    <div class="example-header">
      <mat-form-field class="filterMargin">
        <input matInput (keyup)="applyFilter($event.target.value)" [value]="getOrderListFilter()" placeholder="Filter">
      </mat-form-field>

      <mat-slide-toggle [checked]="showPending" (change)="applyShowPending($event)">Pending</mat-slide-toggle>
      <mat-slide-toggle [checked]="showUrgent" (change)="applyShowUrgent($event)">Urgent</mat-slide-toggle>
      <mat-slide-toggle class="filterMargin" [checked]="showAuthorized" (change)="applyShowAuthorized($event)">Waiting for Authorization</mat-slide-toggle>

      <mat-form-field>
        <input matInput #fromDate placeholder="From Date" [matDatepicker]="fromDate" disabled>
        <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
        <mat-datepicker (selectedChanged)="filterByFromDate($event)" #fromDate disabled="false"></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <input matInput #toDate placeholder="To Date" [matDatepicker]="toDate" disabled>
        <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker (selectedChanged)="filterByToDate($event)" #toDate disabled="false"></mat-datepicker>
      </mat-form-field>

      <button mat-raised-button (click)="resetDatePicker()">Reset Dates</button>
    </div>

    <div class="example-container mat-elevation-z8">

      <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="orderNr">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Order</mat-header-cell>
          <mat-cell *matCellDef="let row">
              <span *ngIf="(row.invoices && row.invoices.length > 0) || (row.deliveryNotes && row.deliveryNotes.length > 0)" title="There are invoices or delivery notes without an association to their materials">
                <mat-icon color="warn">warning</mat-icon>
              </span>
              {{ row.orderNr }}          
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="project">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Project</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div>{{ row.projects?.join(',') }}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="author">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Author</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div>{{ row.author.displayName }}</div>
            <a target="_blank" [href]="'https://mail.google.com/mail/u/0/?view=cm&fs=1&to='+ row.author.email">
              <span class="author-email">
                {{ row.author.email }}
              </span>
            </a>
          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="vendor">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Vendor</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div> {{ row.vendor.name }} </div>
            <a *ngIf="row.primaryContact?.emails" target="_blank" [href]="'https://mail.google.com/mail/u/0/?view=cm&fs=1&to='+ row.primaryContact.emails[0].email">
              <span class="author-email">
                {{ row.primaryContact.name }}
              </span>
              <span class="author-email">
                  &#x3C;{{ row.primaryContact.emails[0].email }}&#x3E;
                </span>
            </a>
          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="total">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Total</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.totalValue | currency:'EUR' }} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Date</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.date | date }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="invoiceCompletion">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Invoice %</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{ row.orderInvoiceCompletion || 0 }}%</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ddtCompletion">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Delivery %</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{ row.orderDeliveryCompletion || 0 }}%</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ddt">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Delivery Notes</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngFor="let ddt of row.ddtList">
              <a [routerLink]="['/ddt/',ddt.ddtId]" target="_blank" class="ddt-list" [title]="ddt.ddtDate | date">{{ ddt.ddtNr }}</a>,
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Urgent</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngIf="row.urgent">
              <mat-icon color="warn" [title]="row.deliveryDate | date">watch_later</mat-icon>  
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="authorized">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Authorized</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngIf="!row.authorized">
              <mat-icon color="primary" [title]="row.date | date">done_outline</mat-icon>
            </span>
            <span *ngIf="row.authorized && row.authorized == 'yes'">
              <mat-icon color="primary" [title]="row.authorizationDate | date">done_outline</mat-icon>
            </span>
            <span *ngIf="row.authorized && row.authorized == 'waiting'">
              <mat-icon title="waiting for authorization">access_time</mat-icon>  
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="driveUrl">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Drive</mat-header-cell>
            <mat-cell *matCellDef="let row"> 
            <a *ngIf="row.driveUrl && (!row.authorized || row.authorized == 'yes')" target="_blank" [href]="row.driveUrl" mat-icon-button>
                <img src="assets/img/drive.png" alt="Google Drive">
              </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef i18n>Actions</mat-header-cell>
            <mat-cell *matCellDef="let row"> 
                <button *ngIf="!row.authorized || row.authorized == 'yes'" [disabled]="orderPrepare.get(row.id)" mat-icon-button (click)="prepareOrderPdf(row)">
                  <mat-icon title="create pdf order">mail_outline</mat-icon>
                </button>
                <button *ngIf="row.authorized && row.authorized == 'no'" [disabled]="orderPrepare.get(row.id)" mat-icon-button (click)="askOrderAuth(row)">
                  <mat-icon title="ask for authorization">vpn_key</mat-icon>
                </button>
                <a mat-icon-button [routerLink]="['/order/view',row.id]">
                  <mat-icon title="open order">visibility</mat-icon>
                </a>
                <button mat-icon-button *ngIf="!orderHasInvoices(row)" [disabled]="orderPrepare.get(row.id)" (click)="deleteOrder(row)">
                  <mat-icon title="delete order">delete</mat-icon>
                </button>
            </mat-cell>
          </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>

      <mat-paginator [length]="dataSource.resultsLength" [pageSize]="pageSize" (page)="savePageSize($event)" [pageSizeOptions]="[50, 100, 200, 500]"></mat-paginator>
    </div>
  </mat-card>
</div>


// WEBPACK FOOTER //
// ./src/app/order/order-list/order-list.component.html